module.exports = "arrow-right"